import {
  SEARCH_APPOINTMENT_LIST,
  SEARCH_APPOINTMENT_LIST_FAILURE,
  SEARCH_APPOINTMENT_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getSearchAppointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_APPOINTMENT_LIST:
      return { ...state, loading: true };
    case SEARCH_APPOINTMENT_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case SEARCH_APPOINTMENT_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getSearchAppointmentReducer;
